module.exports = __webpack_public_path__ + "static/media/DSC00571-55_Small.4cacb9eb.jpg";